/* eslint-disable react/jsx-no-useless-fragment,react/no-deprecated */
import React, { Fragment } from 'react';
import {
  string, number, func, node, bool,
} from 'prop-types';
import {
  Modal,
  Heading,
  Button,
  Icon,
} from 'components/common';

import './CloseableModal.scss';
import HtmlParser from './HtmlParser';

class CloseableModal extends React.Component {
  constructor() {
    super();
    this.state = {
      isVisible: false,
    };
  }

  componentWillMount() {
    document.addEventListener('click', this.handleOverlayClick, false);
    document.addEventListener('keydown', this.handleEscapeKeyPress, false);
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  }

  componentDidMount() {
    const { delay } = this.props;
    setTimeout(() => {
      this.setState({
        isVisible: true,
      });
    }, delay);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleOverlayClick, false);
    document.removeEventListener('keydown', this.handleEscapeKeyPress, false);
    document.body.style.overflow = null;
    document.documentElement.style.overflow = null;
  }

  localOnClose = () => {
    const { onClose } = this.props;
    if (onClose) {
      document.removeEventListener('click', this.handleOverlayClick, false);
      document.removeEventListener('keydown', this.handleEscapeKeyPress, false);
      document.body.style.overflow = null;
      document.documentElement.style.overflow = null;
      onClose();
    }
  }

  handleEscapeKeyPress = (e) => {
    if (e.keyCode === 27 /* Escape */) {
      this.localOnClose();
    }
  };

  handleOverlayClick = (e) => {
    if (e?.srcElement?.classList?.value === 'overlay') {
      this.localOnClose();
    }
  };

  render() {
    const { isVisible } = this.state;
    const {
      title, descriptionHtml, closeText, acceptsHTML, children,
    } = this.props;
    return isVisible && (
      <div className="closeable-modal-view">
        <Modal
          modalBoxClassName="closeable-modal-box"
        >
          <div className="closeable-modal-top">
            <Heading className="closeable-modal-top-heading" as="h2" primary>
              {title}
            </Heading>
            <Button className="closeable-modal-top-close-icon-button" onClick={this.localOnClose} text>
              <Icon name="cancel" medium primary />
            </Button>

          </div>
          <div className="closeable-modal-body">
            {acceptsHTML ? (<HtmlParser htmlString={descriptionHtml} className="bodyParagraph" />) : children}
          </div>
          <div className="closeable-modal-bottom">
            <Button className="closeable-modal-close-button" primary onClick={this.localOnClose}>{closeText}</Button>
          </div>
        </Modal>
      </div>
    );
  }
}

CloseableModal.propTypes = {
  title: string.isRequired,
  descriptionHtml: string.isRequired,
  onClose: func.isRequired,
  delay: number,
  closeText: string,
  children: node,
  acceptsHTML: bool,
};
CloseableModal.defaultProps = {
  closeText: 'Close',
  delay: 0,
  children: <Fragment />,
  acceptsHTML: true,
};

export default CloseableModal;
